/**
 * Created  on 19/10/18.
 * loading调用
 *
 * @param type (true/false)
 *
 * true：显示loading
 * false：去除loading
 */
import {Toast} from 'vant'


export function loading(type,message) {
    if(!message){
        message= '加载中...';
    }
    if(type === true ) {
        Toast.loading({
            mask: true,
            message:message,
            duration: 0,
        })
    }else if(type === false){
        Toast.clear();
    }
}